export default {
  computed: {
    hostURL() {
      return window.omnifyConfig.hostURL;
    },
    vapidPublicKey() {
      return window.omnifyConfig.vapidPublicKey;
    },
    enabledLanguages() {
      return window.omnifyConfig.enabledLanguages;
    },
    isEnterprise() {
      return window.omnifyConfig.isEnterprise === 'true';
    },
    enterprisePlanName() {
      // returns "community" or "enterprise"
      return window.omnifyConfig?.enterprisePlanName;
    },
  },
};
